
import { defineComponent } from "vue";
import "normalize.css";
import "@/assets/css/main.css";
import "@/assets/css/theme.css";

export default defineComponent({});
